import axios from "axios";

export default function getTickets({
  page,
  length,
  search = "",
  status = "",
  priority = "",
  smartkoodModule = "",
  assigneeId = "",
  companyId = "",
  dateFrom = "",
  dateTo = "",
  sortBy = "created_at",
  sortOrder = "desc",
}) {
  const start = page * length;
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/tickets", {
        params: {
          start,
          length,
          search,
          status,
          priority,
          smartkood_module: smartkoodModule,
          assignee_id: assigneeId,
          company_id: companyId,
          date_from: dateFrom,
          date_to: dateTo,
          sort_by: sortBy,
          sort_order: sortOrder,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
